module.exports = __webpack_public_path__ + "media/images/riders/small/LAURA_STIGGER-b57b72e5d1971cc506fbaf4e28925101.png";